import { render, staticRenderFns } from "./kpsrGuidewordPop.vue?vue&type=template&id=61cb0588"
import script from "./kpsrGuidewordPop.vue?vue&type=script&lang=js"
export * from "./kpsrGuidewordPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61cb0588')) {
      api.createRecord('61cb0588', component.options)
    } else {
      api.reload('61cb0588', component.options)
    }
    module.hot.accept("./kpsrGuidewordPop.vue?vue&type=template&id=61cb0588", function () {
      api.rerender('61cb0588', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/base/kpsrGuidewordPop.vue"
export default component.exports